import React from 'react'
import { Link } from 'gatsby'
import Container from './styles'
import iconAgenda from '../../icons/icon-agenda.svg'
import iconAcomodacoes from '../../icons/icon-acomodacoes.svg'
import iconExames from '../../icons/icon-exames.svg'
import iconMaternidade from '../../icons/icon-maternidade.svg'

const LinksDestaque = () => (
  <Container>
    <li>
      <a
        href="https://gruposantajoana.com.br/videochamada/hmsj/"
        target="_blank"
        rel="noreferrer"
      >
        <img src={iconAgenda} alt="Agendar visita" />
        agendar visita
      </a>
    </li>
    <li>
      <Link to="/exames">
        <img src={iconExames} alt="Resultado de exames" />
        resultado de exames
      </Link>
    </li>
    <li>
      <Link to="/acomodacoes">
        <img src={iconAcomodacoes} alt="Nossas acomodaçoes" />
        nossas acomodaçoes
      </Link>
    </li>
    <li>
      <Link to="/plano-maternidade">
        <img src={iconMaternidade} alt="Plano Maternidade" />
        plano maternidade
      </Link>
    </li>
  </Container>
)

export default LinksDestaque
